"use client";

import * as React from "react";
import * as LabelPrimitive from "@radix-ui/react-label";

import { cn } from "./utils";

const RadixLabel = LabelPrimitive as any;
const LabelRoot = (RadixLabel as any)?.Root ?? (RadixLabel as any)?.Label ?? RadixLabel;
const hasRadixLabel = typeof LabelRoot !== "undefined";
let hasWarnedMissingRadixLabel = false;
const warnMissingRadixLabel = () => {
  if (hasWarnedMissingRadixLabel) return;
  hasWarnedMissingRadixLabel = true;
  console.warn("[ui/label] Radix Label unavailable. Falling back to <label>.");
};

const filterGeneratedProps = (props: any) => {
  const clean: any = {};
  for (const key in props) {
    if (!key.startsWith("_fg")) {
      clean[key] = props[key];
    }
  }
  return clean;
};

function Label({
  className,
  ...props
}: React.ComponentProps<typeof LabelPrimitive.Root>) {
  const cleanProps = filterGeneratedProps(props);
  const { htmlFor, ...restProps } = cleanProps as any;
  const sharedClassName = cn(
    "flex items-center gap-2 text-[length:var(--text-label)] leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
    className,
  );

  if (!htmlFor) {
    return (
      <div
        data-slot="label"
        className={sharedClassName}
        {...restProps}
      />
    );
  }

  if (!hasRadixLabel) {
    warnMissingRadixLabel();
    return (
      <label
        data-slot="label-fallback"
        htmlFor={htmlFor}
        className={sharedClassName}
        {...restProps}
      />
    );
  }
  const Root = LabelRoot as typeof LabelPrimitive.Root;
  return (
    <Root
      data-slot="label"
      htmlFor={htmlFor}
      className={sharedClassName}
      {...restProps}
    />
  );
}

export { Label };
